angular.module('vskoToolbar', [])


.directive('vskoToolbar', function() {
  return {
    restrict: 'E',
    replace: true,
    require:'?^vskoPanelHeading',
    transclude: {
      'toolbarElement': '?vskoToolbarElement'
    },
    scope: {
      size: '@'
    },
    template: require('./vsko-toolbar.html'),
    link: function(scope, element, attrs, panelHeadingCtrl, transclude) {
        
        if (panelHeadingCtrl){
          scope.internalToolbar = angular.isDefined(attrs.internalToolbar);
          panelHeadingCtrl.addToolbar(scope);
          if (panelHeadingCtrl.panelScope.isCollapsable) {
            scope.isParentCollapsable = true;
            scope.collapsableButton = panelHeadingCtrl.collapsableButton;
            scope.panelScope = panelHeadingCtrl.panelScope; 
          }
        }

        transclude(function (contents) { 
          angular.forEach(contents, function(content) {
            var selector = '.bc-toolbar-' + (content.getAttribute('position') || 'left');
            element.find(selector).append(content);
          });
        }, null, 'toolbarElement'); 

    }
  };
})

.directive('vskoToolbarElement', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      position:'@'
    },
    template: require('./vsko-toolbar-element.html'),
    link: function(scope, element, attrs, ctrl, transclude) {
    }
  };
})
.directive('vskoToolbarElementTitle', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('./vsko-toolbar-element-title.html')
  };
})
